export default __webpack_public_path__ + "static/media/ImageClose.92f483ac.svg";